import { Container, Modal } from "@mui/material";
import PlusIcon from "assets/icons/PlusIcon";
import RefreshIcon from "assets/icons/RefreshIcon";
import PageHeader from "components/Shared/PageHeader";
import Table from "components/Table2";
import useUpdatePrice from "./data";
import Portal from "components/Portal";
import { useState } from "react";
import Plans from "./modals/Plans";
import BasicButton from "components/BasicInputs/BasicButton";
import AddPlan from "./modals/AddPlan";
import Change, { ChangePricesState } from "./modals/Change";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import ModalBox from "components/Shared/Modals/ModalBox";
import { ExportContainer, Item, StyledListItemIcon, StyledListItemText } from "../Table/ExportBotton";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
const xlsx = require("xlsx");


import SaveIcon from "assets/icons/invoice/SaveIcon";
import { store } from "store/store";
import { apiProductPriceListExcel } from "api/productApi";
import { appSetAlert } from "store/actions/appAction";

export interface UpdatePricesState {
  open?: "plans" | "addPlan" | "change";
  plan?: Plan;
  submitChange?: boolean;
  submitAddPlan?: boolean;
}

export default function UpdatePrices() {
  const { table, pricePlans, plans, addPlan, deletePlan, changePrices, savePrices } = useUpdatePrice();
  const [state, setState] = useState<UpdatePricesState>({});

  function handleAddPlan(plan: Plan) {
    setState((x) => ({ ...x, submitAddPlan: false }));
    addPlan(plan).then(() => {
      setState((x) => ({ ...x, open: "plans" }));
    });
  }

  function handleDeletePlan(item: any) {
    deletePlan(item);
  }

  function handleChange(state: ChangePricesState, fromSpeed?: boolean) {
    setState((x) => ({ ...x, submitChange: false, open: undefined }));
    changePrices(state, fromSpeed);
  }

  const modalPages = {
    plans: {
      title: "لیست قیمت ها",
      body: (
        <Plans
          onDelete={handleDeletePlan}
          onEdit={(item) => setState((x) => ({ ...x, open: "addPlan", plan: item }))}
          plans={pricePlans}
        />
      ),
      footer: (
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <BasicButton
            variant="contained"
            onClick={() => setState((x) => ({ ...x, open: "addPlan", plan: undefined }))}
          >
            <PlusIcon color="#fff" scale={0.7} />
            <span>افزودن لیست قیمت</span>
          </BasicButton>
        </div>
      ),
    },
    addPlan: {
      title: state.plan ? "ویرایش لیست قیمت" : "افزودن لیست قیمت",
      body: <AddPlan onSubmit={handleAddPlan} plan={state.plan} submit={state.submitAddPlan} />,
      footer: (
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <BasicButton
            style={{ color: "#7D96B8", borderColor: "#7D96B8" }}
            variant="outlined"
            onClick={() => setState((x) => ({ ...x, open: "plans" }))}
          >
            <ArrowBackIcon color="#7D96B8" />
            <span>بازگشت</span>
          </BasicButton>
          <BasicButton variant="contained" onClick={() => setState((x) => ({ ...x, submitAddPlan: true }))}>
            {state.plan ? <span>ویرایش لیست</span> : <span>ایجاد لیست</span>}
          </BasicButton>
        </div>
      ),
    },
    change: {
      title: "تغییر قیمت سریع",
      body: <Change submit={state.submitChange} onsubmit={handleChange} plans={plans} />,
      footer: (
        <BasicButton
          variant="contained"
          fullWidth
          onClick={() => setState((x) => ({ ...x, submitChange: true }))}
        >
          اعمال تغییرات
        </BasicButton>
      ),
    },
  };
  const downloadExcel = (type: "excel" | "pdf") => {
    const token = store.getState().businessReducer?.business?.token
    store.dispatch(apiProductPriceListExcel(token, (res: any) => {
      store.dispatch(appSetAlert("فایل با موفقیت دانلود شد", "success"));
    }))
  }
  const modalPage = state.open && modalPages[state.open];

  return (
    <Container style={{ marginBottom: 80 }}>
      <PageHeader
        heading="بروزرسانی قیمت ها"
        subHeading="نمایش لیست قیمت های کالا/خدمات"
        actionSection={
          <div className="flex justify-between gap-4">
            <ExportContainer>
              <Item disableRipple onClick={() => downloadExcel("excel")}>
                <StyledListItemIcon>
                  <SnippetFolderIcon color="success" />
                </StyledListItemIcon>
                <StyledListItemText> دانلود اکسل لیست قیمت</StyledListItemText>
              </Item>
            </ExportContainer>
            <div className="flex flex-wrap gap-2 my-2">
              <BasicButton
                className="min-w-[40px] md:min-w-[128px]"
                variant="outlined"
                color="disabled"
                onClick={() => setState((x) => ({ ...x, open: "change" }))}
              >
                <RefreshIcon scale={0.9} color="#747575" />
                <span className="hidden md:block text-dark-3">بروزرسانی سریع</span>
              </BasicButton>
              <BasicButton
                className="min-w-[40px] md:min-w-[128px]"
                variant="outlined"
                onClick={() => setState((x) => ({ ...x, open: "plans" }))}
              >
                <PlusIcon color="#1062D0" scale={0.7} />
                <span className="hidden md:block">افزودن لیست قیمت</span>
              </BasicButton>
              <BasicButton
                className="min-w-[40px] md:min-w-[128px]"
                variant="contained"
                onClick={() => savePrices()}
              >
                <SaveIcon color="#fff" />
                <span className="hidden md:block">ذخیره قیمت ها</span>
              </BasicButton>

            </div>

          </div>

        }
      />
      <Table {...table} withoutMenu withExport={false} />
      <Portal>
        <Modal open={Boolean(state.open)}>
          {modalPage ? (
            <ModalBox
              title={modalPage.title || ""}
              onClose={() => setState((x) => ({ ...x, open: undefined }))}
              style={{ container: { width: 425 } }}
              footer={modalPage.footer}
            >
              {modalPage.body}
            </ModalBox>
          ) : (
            <></>
          )}
        </Modal>
      </Portal>
    </Container>
  );
}
